module.exports = __webpack_public_path__ + "img/katarina_living_room_9.de9172c7.jpg";